import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  ColumnaTablaFullscreen,
  formatearCeldaTabla
} from '../../utils/grafico-fullscreen-tabla.util';

@Component({
  selector: 'app-grafico-fullscreen-tabla',
  template: `
    <div class="grafico-fullscreen-tabla" *ngIf="filas.length > 0">
      <div class="tabla-responsive">
        <table>
          <thead>
            <tr>
              <th *ngFor="let col of columnas; trackBy: trackByKey"
                [class.ion-text-center]="col.align === 'center'">
                {{ col.label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let fila of filas; let i = index; trackBy: trackByIndex">
              <td *ngFor="let col of columnas; trackBy: trackByKey"
                [class.ion-text-center]="col.align === 'center'">
                {{ textoCelda(fila, col) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      min-width: 0;
      box-sizing: border-box;
    }

    table {
      table-layout: fixed;
    }

    thead th {
      white-space: normal;
      overflow-wrap: break-word;
      word-break: break-word;
      line-height: 1.25;
      vertical-align: bottom;
      padding: 6px 4px;
      font-size: 0.72rem;
    }

    tbody td {
      overflow-wrap: break-word;
      word-break: break-word;
      padding: 6px 4px;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GraficoFullscreenTablaComponent {
  @Input() columnas: ColumnaTablaFullscreen[] = [];
  @Input() filas: Record<string, string | number>[] = [];

  textoCelda(fila: Record<string, string | number>, col: ColumnaTablaFullscreen): string {
    return formatearCeldaTabla(fila[col.key], col);
  }

  trackByKey(_index: number, col: ColumnaTablaFullscreen): string {
    return col.key;
  }

  trackByIndex(index: number): number {
    return index;
  }
}
